import React from 'react';

interface SkeletonProps {
  className?: string;
  style?: React.CSSProperties;
}

export const Skeleton: React.FC<SkeletonProps> = ({ className = '', style }) => (
  <div
    className={`skeleton ${className}`}
    style={{ borderRadius: 6, ...style }}
    aria-hidden="true"
  />
);

/* ── Stock hero loading state ── */
export const StockHeroSkeleton: React.FC = () => (
  <div aria-label="Loading stock data">
    {/* Header row */}
    <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid #1e2d45', background: '#0f1621', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.75rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.875rem' }}>
        <div className="skeleton" style={{ width: 100, height: 44, borderRadius: 10 }} />
        <div>
          <div className="skeleton" style={{ width: 160, height: 14, marginBottom: 8 }} />
          <div className="skeleton" style={{ width: 80, height: 10 }} />
        </div>
      </div>
      <div style={{ textAlign: 'right' }}>
        <div className="skeleton" style={{ width: 130, height: 32, marginBottom: 10, marginLeft: 'auto' }} />
        <div className="skeleton" style={{ width: 100, height: 22, marginLeft: 'auto' }} />
      </div>
    </div>
    {/* Metrics row */}
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '1px', background: '#1e2d45' }}>
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} style={{ background: '#111827', padding: '1rem 1.25rem' }}>
          <div className="skeleton" style={{ width: 60, height: 10, marginBottom: 8 }} />
          <div className="skeleton" style={{ width: 90, height: 18 }} />
        </div>
      ))}
    </div>
  </div>
);

/* ── Chart loading state ── */
export const ChartSkeleton: React.FC = () => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.875rem' }} aria-label="Loading chart">
    <div className="skeleton" style={{ width: 120, height: 16 }} />
    <div className="skeleton" style={{ width: '100%', height: 300, borderRadius: 10 }} />
  </div>
);

/* ── Market indices loading state ── */
export const IndicesSkeleton: React.FC = () => (
  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1px', background: '#1a2235' }} aria-label="Loading market indices">
    {Array.from({ length: 3 }).map((_, i) => (
      <div key={i} style={{ background: '#111827', padding: '1.25rem 1.5rem' }}>
        <div className="skeleton" style={{ width: 80, height: 13, marginBottom: 6 }} />
        <div className="skeleton" style={{ width: 40, height: 10, marginBottom: 18 }} />
        <div className="skeleton" style={{ width: 120, height: 28, marginBottom: 10 }} />
        <div className="skeleton" style={{ width: 90, height: 10, marginBottom: 6 }} />
        <div className="skeleton" style={{ width: 60, height: 10 }} />
      </div>
    ))}
  </div>
);

/* ── Card list (news) loading state ── */
export const CardListSkeleton: React.FC<{ rows?: number }> = ({ rows = 4 }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.875rem' }} aria-label="Loading content">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} style={{ display: 'flex', gap: '0.75rem' }}>
        <div className="skeleton" style={{ width: 60, height: 60, borderRadius: 8, flexShrink: 0 }} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6, paddingTop: 4 }}>
          <div className="skeleton" style={{ width: '100%', height: 13 }} />
          <div className="skeleton" style={{ width: '80%', height: 12 }} />
          <div className="skeleton" style={{ width: '35%', height: 10 }} />
        </div>
      </div>
    ))}
  </div>
);
